<style scoped>
.symbol-wrapper {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 18px;
  color: var(--color-text-light);
}

.box1 {
  /*padding-top: 20px;*/
  /*padding-bottom: 30px;*/
  /*padding-left: 20px;*/
  /*padding-right: 20px;*/
  /*margin-top: 10px;*/
  /*width: 440px*/
}

.text-cell {
  /*width: 120px;*/
  text-align: left;
  height: 38px;
  font-size: 12px;
  color: var(--color-neutral-light);
}

.value-cell {
  text-align: right;
}

.input {
  /*width: 34px;*/
  font-size: 14px;
}

.err-text {
  font-size: 12px;
  color:var(--color-danger-light);
}

.err-cell {
  height: 15px;
  margin-top: -12px;
  text-align: right;
}

.hint-icon {
  color: var(--color-neutral-light);
  padding-bottom: 3px;
}

.toggle-cell {
  padding-right: 10px;
}

.free-balance-text {
  font-size: 11px;
  color: var(--color-text-dark);
  font-weight: bold;
}

.clsbtn {
  color: var(--color-text-dark);
}

.clsbtn:hover {
  color: var(--color-neutral-light);
}

.amount-percent {
  font-size: 12px;
  cursor: pointer;
  padding-left: 10px;
  color: var(--color-accent-dark);
}

.amount-percent:hover {
  text-decoration: underline;
}

.accum {
  font-size: 12px;
}

td {
  /*border: 1px solid #404364;*/
  /*border: 1px solid red;*/
}

div {
  /*border: 1px solid yellow;*/
}
</style>

<template>
  <div>
    <BotOrdersModal
      :show="botOrdersModalShow"
      :orders="botOrders"
      :botName="bot.Name"
      :symbol="bot.Symbol"
      @on-cancel="botOrdersModalShow = false"
    />
    <div
      class="box symbbox"
      style="height: 100%; padding: 10px 10px; display: flex; flex-direction: column;"
    >
      <table style="width: 100%; border-spacing: 0;">
        <tr>
          <td
            colspan="2"
            class="text-cell"
          >
            <SymbolsChooser
              v-if="!bot.Id"
              v-model="symbol"
              :symbols="botSymbols"
              @click="selectSymbol"
              botsStyle
            />
            <div v-else>
              <div class="symbol-wrapper">
                <CoinIcon :symbol="symbol" />
                <span>{{ symbol }}</span>
                <Icon
                  style="cursor: pointer;"
                  :title="$text.tr('Показать сделки')"
                  type="ios-list-box-outline"
                  color="var(--color-text-dark)"
                  @click="getBotOrders()"
                ></Icon>
              </div>
              <div style="font-size: 12px; color: var(--color-text-dark); cursor: pointer" @click="$copyToClipboardAndNotify(bot.Id)">#{{ bot.Id }}</div>
            </div>
          </td>
          <td
            class="value-cell"
            style="vertical-align: bottom; padding-bottom: 8px;"
          >
            <div class="free-balance-text">{{ $text.tr('ДОСТУПНО') }}</div>
            <div :class="{'blur-balance': $store.state.sys.hideBalances}"><div>{{ balanceTrunc }} {{ currency }}</div></div>
          </td>
        </tr>
        <tr>
          <td
            colspan="3"
            style="padding-bottom: 7px; padding-top: 3px"
          >
            <RadioGroup
              style="width: 100%"
              v-model="eb.accumulateType"
              type="button"
              size="small"
              @on-change="accumulateChanged"
            >
              <Radio
                :disabled="botId !== ''"
                label="B"
                class="accum"
              >{{ $text.tr('КОПИТЬ') }} {{ symbol.split('/')[0] }}</Radio>
              <Radio
                :disabled="botId !== ''"
                label="Q"
                class="accum"
              >{{ $text.tr('КОПИТЬ') }} {{ symbol.split('/')[1] }}</Radio>
              <Radio
                :disabled="botId !== ''"
                label="R"
                class="accum"
              >{{ $text.tr('РЕИНВЕСТ') }}</Radio>
            </RadioGroup>
          </td>
        </tr>
        <tr>
          <td
            colspan="2"
            class="text-cell"
          >{{ $text.tr('НАЗВАНИЕ') }}</td>
          <td class="value-cell">
            <i-input
              v-model="eb.botName"
              type="text"
              @on-change="saveNeeded = true"
              size="small"
              :maxlength="20"
            >
            </i-input>
          </td>
        </tr>
        <tr>
          <td
            colspan="2"
            class="text-cell"
          >{{ $text.tr('СУММА ИНВЕСТИЦИЙ') }}</td>
          <td class="value-cell">
            <i-input
              :disabled="bot.Stage === 'WAITSELL'"
              @on-change="amountChanged"
              size="small"
              :value="eb.amount"
              @on-keydown="onkeyDown($event)"
            >
              <span slot="append">
                <div class="input">{{ currency }}</div>
              </span>
            </i-input>
          </td>
        </tr>
        <tr style="height: 25px;">
          <td
            colspan="2"
            style="text-align: left;"
          >
            <div
              v-if="bot.Stage !== 'WAITSELL'"
              style="margin-top: -15px;"
            >
              <span
                class="amount-percent"
                style="padding-left: 0px"
                @click="percentFromAmount(10)"
              >10%</span>
              <span
                class="amount-percent"
                @click="percentFromAmount(25)"
              >25%</span>
              <span
                class="amount-percent"
                @click="percentFromAmount(50)"
              >50%</span>
              <span
                class="amount-percent"
                @click="percentFromAmount(100)"
              >100%</span>
            </div>
          </td>
          <td>
            <Slider
              v-if="balance === 0"
              style="margin-top: -15px; height: 20px"
              show-tip="never"
              :min="0"
              :max="1"
              :step="1"
            ></Slider>
            <Slider
              v-else-if="bot.Stage !== 'WAITSELL'"
              @on-change="sliderChanged"
              style="margin-top: -15px; height: 20px"
              :value="amountSlider"
              show-tip="never"
              :min="0"
              :max="balance"
              :step="minAmount"
            ></Slider>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <div
              class="err-text err-cell"
              style="margin-top: -15px"
            >
              {{ amountErr }}
            </div>
          </td>
        </tr>
        <tr>
          <td
            colspan="2"
            class="text-cell"
          >{{ $text.tr('УРОВЕНЬ ПОКУПКИ') }}</td>
          <td class="value-cell">
            <i-input
              @on-change="saveNeeded = true"
              size="small"
              v-model="eb.buyPrice"
              @on-keydown="onkeyDown($event)"
            >
              <span slot="append">
                <div class="input">{{ currency }}</div>
              </span>
            </i-input>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <div class="err-text err-cell">
              {{ buyPriceErr }}
            </div>
          </td>
        </tr>
        <tr>
          <td
            colspan="2"
            class="text-cell"
          >{{ $text.tr('УРОВЕНЬ ПРОДАЖИ') }}</td>
          <td class="value-cell">
            <i-input
              size="small"
              v-model="eb.sellPrice"
              @on-change="saveNeeded = true"
              @on-keydown="onkeyDown($event)"
            >
              <span slot="append">
                <div class="input">{{ currency }}</div>
              </span>
            </i-input>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <div class="err-text err-cell">
              {{ sellPriceErr }}
            </div>
          </td>
        </tr>
        <tr>
          <td class="text-cell">
            {{ $text.tr('ТРИГГЕР-ЦЕНА') }}
            <Tooltip
              :delay="500"
              max-width="261"
              placement="bottom-start"
            >
              <Icon
                class="hint-icon"
                type="ios-information-circle-outline"
              ></Icon>
              <div slot="content">{{ $text.tr('Если цена опустится ниже триггер-цены, то ордер на покупку будет размещен на бирже.\nЕсли цена поднимется выше триггер-цены, то ордер на покупку будет снят с биржи.\nОбратите внимание, ордера с триггером не всегда срабатывают при сквизах.') }} <a
                  style="color: var(--color-accent-dark)"
                  target="_blank"
                  :href="$text.tr('https://doc.capico.app/v/ru/terminal/orders')"
              >{{ $text.tr('Подробнее') }}</a></div>
            </Tooltip>
          </td>
          <td class="toggle-cell">
            <i-switch
              v-model="eb.trigger"
              @on-change="triggerSwitched"
              size="small"
            />
          </td>
          <td class="value-cell">
            <i-input
              @on-change="saveNeeded = true"
              v-if="eb.trigger"
              size="small"
              v-model="eb.triggerPrice"
              @on-keydown="onkeyDown($event)"
            >
              <span slot="append">
                <div class="input">{{ currency }}</div>
              </span>
            </i-input>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <div class="err-text err-cell">
              <div v-if="eb.trigger">{{ triggerPriceErr }}</div>
            </div>
          </td>
        </tr>
        <tr>
          <td class="text-cell">
            STOP LOSS
          </td>
          <td class="toggle-cell">
            <i-switch
              v-model="eb.stopLoss"
              @on-change="stopLossSwitched"
              size="small"
            />
          </td>
          <td class="value-cell">
            <i-input
              v-if="eb.stopLoss"
              size="small"
              @on-change="saveNeeded = true"
              v-model="eb.slPrice"
              @on-keydown="onkeyDown($event)"
            >
              <span slot="append">
                <div class="input">{{ currency }}</div>
              </span>
            </i-input>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <div class="err-text err-cell">
              <div v-if="eb.stopLoss">{{ slPriceErr }}</div>
            </div>
          </td>
        </tr>
        <tr v-if="eb.stopLoss">
          <td class="text-cell">
            SL TIMEOUT
            <Tooltip
              :delay="500"
              max-width="260"
              placement="right"
            >
              <Icon
                class="hint-icon"
                type="ios-information-circle-outline"
              ></Icon>
              <div slot="content">{{ $text.tr('При активации Stop Loss система будет ожидать указанное время. Если после этого цена останется в зоне Stop Loss, то сделка закроется рыночным ордером. Данная функция используется для защиты от сквиза.') }} <a
                  style="color: var(--color-accent-dark)"
                  target="_blank"
                  :href="$text.tr('https://doc.capico.app/v/ru/terminal/sl/timeout')"
                >{{ $text.tr('Подробнее') }}</a></div>
            </Tooltip>
          </td>
          <td class="toggle-cell">
            <i-switch
              v-model="eb.slTimeoutEnabled"
              size="small"
              @on-change="saveNeeded = true"
            />
          </td>
          <td class="value-cell">
            <i-input
              v-if="eb.slTimeoutEnabled"
              size="small"
              @on-change="saveNeeded = true"
              v-model="eb.slTimeout"
              @on-keydown="onkeyDown($event)"
            >
              <span slot="append">
                <div class="input">{{ $text.tr('СЕК') }}</div>
              </span>
            </i-input>
          </td>
        </tr>
        <tr v-else>
          <td
            class="text-cell"
            colspan="3"
          >&nbsp;</td>
        </tr>
        <tr>
          <td class="text-cell">
            {{ $text.tr('АВТО-ПЕРЕЗАПУСК') }}
          </td>
          <td class="toggle-cell">
            <i-switch
              v-model="eb.autoLaunch"
              @on-change="saveNeeded = true"
              size="small"
            />
          </td>
          <td></td>
        </tr>
        <tr>
          <td
            colspan="3"
            style="height: 5px;"
          >
          </td>
        </tr>
        <!--      <tr>-->
        <!--        <td colspan="3">-->
        <!--          <Button :disabled="buttonDisable" @click="editBot()" size="small" long style="width: 100%; height: 30px">-->
        <!--            <div style="font-size: 12px">ЗАПУСТИТЬ БОТА</div>-->
        <!--          </Button>-->
        <!--        </td>-->
        <!--      </tr>-->
      </table>
      <div
        slot="footer"
        style="margin-top: auto; margin-bottom: 5px;"
      >
        <div style="display: flex; justify-content: space-between; align-content: flex-end">
          <Icon
            type="ios-close-circle-outline"
            size="30"
            style="cursor: pointer; padding-right: 50px"
            :title="$text.tr('Закрыть окно') + ' (ESC)'"
            class="clsbtn"
            @click="closeEditBot"
          />
          <Button
            :loading="loading"
            :disabled="buttonDisable || !saveNeeded"
            @click="saveClicked"
            size="small"
            long
            style="width: 100%; height: 30px"
          >
            <span style="font-size: 12px">{{ $text.tr(btnText) }}</span>
          </Button>
        </div>
        <!--      <table style="width: 100%; max-width: 570px">-->
        <!--        <tr>-->
        <!--          <td>-->
        <!--            <Button :loading="loading" :disabled="buttonDisable || !saveNeeded" @click="saveClicked" size="small" long style="width: 100%; height: 30px">-->
        <!--              <span style="font-size: 12px">{{ btnText }}</span>-->
        <!--            </Button>-->
        <!--          </td>-->
        <!--          <td style="width: 80px; text-align: right;">-->
        <!--            <Icon type="ios-close-circle-outline" size="30" style="cursor: pointer" class="clsbtn" @click="closeEditBot"/>-->
        <!--&lt;!&ndash;            <Button>&ndash;&gt;-->
        <!--&lt;!&ndash;              X&ndash;&gt;-->
        <!--&lt;!&ndash;            </Button>&ndash;&gt;-->
        <!--          </td>-->
        <!--        </tr>-->
        <!--      </table>-->

      </div>
    </div>

    <!--    </Modal>-->
  </div>
</template>

<script>
import SymbolsChooser from '@/components/common/SymbolsChooser.vue'
import Decimal from 'decimal.js'
import BotApi from '@/util/botapi'
import Bots from '@/services/bots'
import Util from '@/util/util'
import BotOrdersModal from './BotOrdersModal'
import CoinIcon from '@/components/common/CoinIcon.vue'

export default {
  name: 'EditBot',
  components: {
    BotOrdersModal,
    CoinIcon,
    SymbolsChooser
  },
  props: ['bot'],
  data () {
    return {
      headerText: 'НОВЫЙ БОТ',
      btnText: 'ЗАПУСТИТЬ НОВЫЙ БОТ',
      loading: false,
      buttonDisable: false,
      triggerPriceErr: '',
      slPriceErr: '',
      sellPriceErr: '',
      buyPriceErr: '',
      amountErr: '',
      // sellPrice: '',
      // buyPrice: '',
      // amount: '',
      amountSlider: 0,
      balance: 0,
      // slPrice: '',
      // triggerPrice: '',
      // autoLaunch: false,
      // trigger: false,
      // stopLoss: false,
      symbol: '',
      // botName: '',
      botId: '',
      saveNeeded: false,
      botOrders: [],
      botOrdersModalShow: false
    }
  },
  watch: {
    '$store.state.bots.symbol' () {
      this.updSymbol()
      this.updPrices()
    },
    '$store.state.bots.editBot': function (bot) {
      // console.log('editBot changed', bot)
      if (!this.eb.editMode) {
        this.eb.buyPrice = ''
        this.eb.sellPrice = ''
        this.eb.triggerPrice = ''
        this.eb.slPrice = ''
        this.eb.accumulateType = 'Q'
        return
      }
      // console.log('bots.editBot', JSON.stringify(this.bot))
      // console.log('bots.editBot obj', this.bot)
      Bots.UpdateBotBalance().then(() => {
        // console.log('after UpdateBotBalance')
        if (this.bot.Id || this.bot.Status === 'COPY') {
          this.saveNeeded = false
          this.botId = this.bot.Id
          this.headerText =
            this.bot.Status === 'COPY' ? 'НОВЫЙ БОТ' : 'РЕДАКТИРОВАНИЕ БОТА'
          this.btnText =
            this.bot.Status === 'COPY' ? 'ЗАПУСТИТЬ НОВЫЙ БОТ' : 'СОХРАНИТЬ'
          this.eb.botName = this.bot.Name
          this.symbol = this.bot.Symbol.replace('_', '/')
          this.eb.amount = this.bot.Amount
          this.amountSlider = parseFloat(this.bot.Amount)
          this.eb.autoLaunch = this.bot.Relaunch
          this.eb.buyPrice = this.bot.BuyPrice
          this.eb.sellPrice = this.bot.SellPrice
          this.eb.triggerPrice = this.bot.Trigger
          this.eb.trigger = this.eb.triggerPrice !== '0'
          this.eb.slPrice = this.bot.StopLoss
          this.eb.stopLoss = this.eb.slPrice !== '0'
          this.eb.slTimeout = '' + this.bot.SlTimeout
          this.eb.slTimeoutEnabled = this.eb.slTimeout !== '0'
          if (!this.eb.slTimeoutEnabled) {
            this.eb.slTimeout = '60'
          }
          this.eb.accumulateType = this.bot.Accumulate
          if (this.bot.Status === 'COPY') {
            this.saveNeeded = true
            this.calculateBalance()
          } else if (this.$store.state.bots.freeBal) {
            this.balance =
              parseFloat(this.$store.state.bots.freeBal) +
              parseFloat(this.bot.Amount)
          }
        } else {
          this.saveNeeded = true
          this.botId = ''
          this.symbol = this.$store.state.bots.symbol.replace('_', '/')
          this.headerText = 'НОВЫЙ БОТ'
          this.btnText = 'ЗАПУСТИТЬ НОВЫЙ БОТ'
          this.eb.botName = ''
          this.eb.autoLaunch = false
          this.eb.trigger = false
          this.eb.stopLoss = false
          this.eb.slTimeoutEnabled = false
          this.eb.slTimeout = 60
          this.updPrices()
        }
      })
      // console.log('freeBalance', this.$store.state.bots.freeBal)
      // console.log('this.balance', this.balance)
      // console.log('this.amount', this.amount)
      // console.log('this.amountSlider', this.amountSlider)
      // setTimeout(() => console.log('this.amount', this.amount), 1000)
    },
    'eb.trigger': function (tr) {
      this.checkButtonDisable()
    },
    'eb.stopLoss': function (sl) {
      this.checkButtonDisable()
    },
    'eb.amount': function () {
      this.checkErrors()
    },
    'eb.triggerPrice': function () {
      this.checkErrors()
    },
    'eb.buyPrice': function () {
      this.checkErrors()
    },
    'eb.sellPrice': function () {
      this.checkErrors()
    },
    'eb.slPrice': function () {
      this.checkErrors()
    },
    'eb.freeBal': function () {
      // console.log('freeBalance', this.$store.state.bots.freeBal)
      if (!this.eb.freeBal) {
        return
      }

      if (this.bot.Id && this.eb.freeBal) {
        // console.log('freeBalance inside', this.$store.state.bots.freeBal)
        // console.log('balance before', this.eb.freeBal)
        // console.log('this.bot.Amount before', this.eb.amount)
        this.balance = parseFloat(this.eb.freeBal) + parseFloat(this.eb.amount)
        this.checkErrors()
        // console.log('amount inside', this.amount)
        // this.amount = parseFloat(this.bot.Amount)
      } else {
        this.updPrices()
      }
    }
    // '$store.state.bots.symbol': function () {
    //   this.updSymbol()
    // }
  },
  computed: {
    botSymbols () {
      if (this.$store.state.sys.tradeExchange.ExchId === 'FTX') {
        return this.$store.state.data.symbols.filter(symbol => {
          if (!symbol.baseAsset.includes('-')) {
            return true
          }
        })
      }
      return this.$store.state.data.symbols
    },
    balanceTrunc () {
      return new Decimal(this.balance).toDecimalPlaces(8).toString()
    },
    eb () {
      return this.$store.state.bots
    },
    symbolUS () {
      return this.symbol.replace('/', '_')
    },
    minAmount () {
      const filt = this.$store.state.data.symbolsfilter[this.symbolUS]
      if (!filt) {
        return
      }
      if (this.$store.state.sys.tradeExchange.ExchId === 'OKX' || this.$store.state.sys.tradeExchange.ExchId === 'FTX' ||
          parseFloat(filt.AmountMin) === 0) {
        const price = new Decimal(this.$store.state.bots.lastPrice || '0').toDP(filt.PriceDec)
        const amountDec = parseFloat(filt.QtyDec) + parseFloat(filt.PriceDec)
        return price.mul(filt.QtyMin).mul('1.2').toDP(amountDec).toNumber()
      }
      return parseFloat(filt.AmountMin)
    },
    currency () {
      return this.symbol.split('/')[1]
    }
  },
  beforeDestroy () {
    this.$store.commit('destroyModalObservers')
  },
  created () {
    this.updSymbol()
    this.updPrices()
    setTimeout(() => {
      this.$store.state.bots.editBot = {}
    }, 2000)
  },
  mounted () {
    this.$store.commit('setModalObservers', this.closeOnEsc)
  },
  methods: {
    closeOnEsc (event) {
      if (event.keyCode === 27) {
        this.closeEditBot()
      }
    },
    getBotOrders () {
      if (!this.eb.editMode) {
        console.error('not edit mode')
        return
      }
      const ref = this
      BotApi.get('bot/orders', {
        params: {
          token: this.$store.state.sys.token,
          id: ref.botId
        }
      })
        .then(function (response) {
          // console.log(response.data)
          if (response.data !== null) {
            if (!response.data.err) {
              // ok
              ref.botOrders = response.data
              ref.botOrdersModalShow = true
            } else {
              // error
              ref.$Notice.error({
                title: ref.$text.tr('Ошибка'),
                desc: Util.returnTextForErr(response.data.err),
                duration: 10
              })
            }
          } else {
            ref.$Notice.info({
              title: ref.$text.tr('нет ордеров'),
              duration: 1
            })
          }
        })
        .catch(function (error) {
          // error
          console.log(error)
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(error),
            duration: 10
          })
        })
    },
    accumulateChanged () {
      this.saveNeeded = true
    },
    percentFromAmount (percent) {
      if (percent === 100) {
        this.eb.amount = this.balance.toString()
        this.amountSlider = parseFloat(this.balance.toString())
        this.saveNeeded = true
        return
      }
      // let filt = this.$store.state.data.symbolsfilter[this.eb.symbol]
      let newQty = new Decimal(this.balance).div(100).mul(percent)
      // if (filt) {
      const dec1 = this.numAfterDot(this.minAmount)
      newQty = newQty.toDP(dec1, Decimal.ROUND_DOWN)
      // }
      const newQtyStr = newQty.toDecimalPlaces(8).toString()
      this.eb.amount = newQtyStr
      this.amountSlider = parseFloat(newQtyStr)
      this.saveNeeded = true
      // console.log('newQty ' + newQty.toString())
    },
    closeEditBot () {
      this.$store.state.bots.editMode = false
    },
    amountChanged (e) {
      // console.log('amountChanged', e)
      this.eb.amount = e.target.value
      this.amountSlider = parseFloat(e.target.value)
      this.saveNeeded = true
    },
    sliderChanged (value) {
      // console.log('slider changed ' + this.amountSlider)
      this.saveNeeded = true
      this.amountSlider = value
      this.eb.amount = new Decimal(this.amountSlider).toString()
    },
    triggerSwitched (tr) {
      if (tr) {
        const filt = this.$store.state.data.symbolsfilter[this.symbolUS]
        if (!filt) {
          return
        }
        const priceDec = filt.PriceDec
        this.eb.triggerPrice = new Decimal(this.eb.buyPrice)
          .mul(new Decimal(1.005))
          .toDP(priceDec)
          .toString()
      }
      this.saveNeeded = true
    },
    stopLossSwitched (sl) {
      if (sl) {
        const filt = this.$store.state.data.symbolsfilter[this.symbolUS]
        if (!filt) {
          return
        }
        const priceDec = filt.PriceDec
        this.eb.slPrice = new Decimal(this.eb.buyPrice)
          .mul(new Decimal(0.99))
          .toDP(priceDec)
          .toString()
      }
      this.saveNeeded = true
    },
    disableButton (ref, value) {
      ref.loading = value
      ref.buttonDisable = value
    },
    checkButtonDisable () {
      if (
        (this.eb.trigger === true && this.triggerPriceErr !== '') ||
        (this.eb.stopLoss === true && this.slPriceErr !== '') ||
        this.sellPriceErr !== '' ||
        this.buyPriceErr !== '' ||
        this.amountErr !== ''
      ) {
        this.buttonDisable = true
        return
      }
      this.buttonDisable = false
    },
    saveClicked () {
      this.disableButton(this, true)
      const ref = this
      const assets = this.symbol.split('/')
      let relaun = '0'
      if (this.eb.autoLaunch) {
        relaun = '1'
      }
      let trig = this.eb.triggerPrice
      if (!this.eb.trigger) {
        trig = ''
      }
      let sl = this.eb.slPrice
      if (!this.eb.stopLoss) {
        sl = ''
      }
      const params = {
        token: this.$store.state.sys.token,
        id: this.botId,
        etid: this.$store.state.sys.tradeExchange.Id,
        symbol: assets[0] + '_' + assets[1],
        name: this.eb.botName,
        amount: this.eb.amount.toString(),
        buyPrice: this.eb.buyPrice,
        sellPrice: this.eb.sellPrice,
        trigger: trig,
        stopLoss: sl,
        relaunch: relaun,
        accumulate: this.eb.accumulateType
      }
      if (this.eb.slTimeoutEnabled) {
        params.slTimeout = this.eb.slTimeout
      }
      BotApi.get('bot/edit', {
        params
      })
        .then(function (response) {
          // console.log(response.data)
          if (!response.data.err) {
            ref.saveNeeded = false
            ref.disableButton(ref, false)
            ref.$Message.success({
              content: ref.$text.tr('Cохранено'),
              duration: 1
            })
            // ok
          } else {
            // error
            ref.disableButton(ref, false)
            ref.$Notice.error({
              title: ref.$text.tr('Ошибка'),
              desc: Util.returnTextForErr(response.data.err),
              duration: 10
            })
          }
          ref.$store.state.bots.botsUpdated = Date.now()
          setTimeout(() => Bots.UpdateBotBalance(), 500)
        })
        .catch(function (error) {
          // error
          ref.disableButton(ref, false)
          console.log(error)
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: ref.$text.tr(error),
            duration: 10
          })
        })
    },
    calculateBalance () {
      const filt = this.$store.state.data.symbolsfilter[this.symbolUS]
      if (!filt) {
        return
      }
      const priceDec = filt.PriceDec
      // update balance
      const decimalQty = parseFloat(priceDec) + parseFloat(filt.QtyDec)
      const balance = this.$store.state.bots.freeBal || '0'
      const updBalance = new Decimal(balance)
        .toDP(decimalQty, Decimal.ROUND_DOWN)
        .toString()
      this.balance = parseFloat(updBalance)
    },
    updPrices () {
      const filt = this.$store.state.data.symbolsfilter[this.symbolUS]
      if (!filt) {
        return
      }
      const priceDec = filt.PriceDec
      // update amount and balance
      const decimalQty = parseFloat(priceDec) + parseFloat(filt.QtyDec)
      const balance = this.$store.state.bots.freeBal || '0'
      const updBalance = new Decimal(balance)
        .toDP(decimalQty, Decimal.ROUND_DOWN)
        .toString()
      this.balance = parseFloat(updBalance)
      // this.eb.amount = this.balance / 2
      const dec1 = this.numAfterDot(filt.AmountMin)
      this.eb.amount = new Decimal(updBalance)
        .div(2)
        .toDP(dec1, Decimal.ROUND_DOWN)
        .toString()
      this.amountSlider = this.balance / 2
      // update prices
      if (this.$store.state.bots.lastPrice) {
        this.eb.buyPrice = new Decimal(0.99)
          .mul(this.$store.state.bots.lastPrice)
          .toDP(priceDec)
          .toString()
        this.eb.sellPrice = new Decimal(1.01)
          .mul(this.$store.state.bots.lastPrice)
          .toDP(priceDec)
          .toString()
      }
      this.eb.triggerPrice = this.$store.state.bots.lastPrice
      if (this.eb.buyPrice) {
        this.eb.slPrice = new Decimal(this.eb.buyPrice)
          .mul(new Decimal(0.98))
          .toDP(priceDec)
          .toString()
      }
    },
    numAfterDot (numb) {
      if (numb === null || numb === undefined) {
        return 0
      }
      if (typeof numb === 'number') {
        numb = numb.toString()
      }
      if (!numb.includes('.')) {
        return 0
      } else {
        return numb.split('.')[1].length
      }
    },
    checkErrors () {
      const filt = this.$store.state.data.symbolsfilter[this.symbolUS]
      if (!filt) {
        return
      }
      // console.log('QtyDec', filt.QtyDec)
      let minAm = new Decimal(filt.AmountMin).mul('1.2').toString()
      if (filt.QtyDec === 0) {
        minAm = new Decimal(filt.AmountMin).mul('2').toString()
      }
      if (this.$store.state.sys.tradeExchange.ExchId === 'OKX' || this.$store.state.sys.tradeExchange.ExchId === 'FTX') {
        const price = new Decimal(this.$store.state.bots.lastPrice || '0').toDP(filt.PriceDec)
        const amountDec = parseFloat(filt.QtyDec) + parseFloat(filt.PriceDec)
        minAm = price.mul(filt.QtyMin).mul('1.2').toDP(amountDec).toString()
      }
      // check amount
      if (this.eb.amount > this.balance) {
        this.amountErr = this.$text.tr('Недостаточно средств')
      } else if (new Decimal(this.eb.amount).lessThan(minAm)) {
        this.amountErr = this.$text.tr('Минимальная сумма: ') + minAm
      } else {
        this.amountErr = ''
      }

      const priceDec = filt.PriceDec
      const triggerPriceFloat = parseFloat(this.eb.triggerPrice)
      const buyPriceFloat = parseFloat(this.eb.buyPrice)
      const sellPriceFloat = parseFloat(this.eb.sellPrice)
      const slPriceFloat = parseFloat(this.eb.slPrice)

      // check buy price
      if (buyPriceFloat >= sellPriceFloat) {
        this.buyPriceErr = this.$text.tr(
          'Уровень покупки должен быть меньше уровня продажи'
        )
      } else if (this.numAfterDot(this.eb.buyPrice) > priceDec) {
        this.buyPriceErr =
          this.$text.tr('Максимальное число знаков после запятой: ') + priceDec
      } else if (buyPriceFloat === 0 || this.eb.buyPrice === '') {
        this.buyPriceErr = this.$text.tr('Уровень покупки должен быть больше 0')
      } else {
        this.buyPriceErr = ''
      }

      // check sell price
      if (buyPriceFloat >= sellPriceFloat) {
        this.sellPriceErr = this.$text.tr(
          'Уровень продажи должен быть больше уровня покупки'
        )
      } else if (this.numAfterDot(this.eb.sellPrice) > priceDec) {
        this.sellPriceErr =
          this.$text.tr('Максимальное число знаков после запятой: ') + priceDec
      } else if (sellPriceFloat === 0 || this.eb.sellPrice === '') {
        this.sellPriceErr = this.$text.tr(
          'Уровень продажи должен быть больше 0'
        )
      } else {
        this.sellPriceErr = ''
      }

      // check trigger price
      if (triggerPriceFloat <= buyPriceFloat) {
        this.triggerPriceErr = this.$text.tr(
          'Триггер-цена должна быть выше уровня покупки'
        )
      } else if (this.numAfterDot(this.eb.triggerPrice) > priceDec) {
        this.triggerPriceErr =
          this.$text.tr('Максимальное число знаков после запятой: ') + priceDec
      } else if (triggerPriceFloat === 0 || this.eb.triggerPrice === '') {
        this.triggerPriceErr = this.$text.tr(
          'Триггер-цена должна быть больше 0'
        )
      } else {
        this.triggerPriceErr = ''
      }

      // check stop loss price
      if (slPriceFloat >= buyPriceFloat) {
        this.slPriceErr = this.$text.tr('SL должен быть меньше уровня покупки')
      } else if (this.numAfterDot(this.eb.slPrice) > priceDec) {
        this.slPriceErr =
          this.$text.tr('Максимальное число знаков после запятой: ') + priceDec
      } else if (slPriceFloat === 0 || this.eb.slPrice === '') {
        this.slPriceErr = this.$text.tr('SL должен быть больше 0')
      } else {
        this.slPriceErr = ''
      }
      this.checkButtonDisable()
    },
    updSymbol () {
      const assets = this.$store.state.bots.symbol.split('_')
      this.symbol = assets[0] + '/' + assets[1]
      // console.log('updSymbol', this.symbol)
    },
    selectSymbol (symbol) {
      Bots.SelectBotSymbol(symbol.replace('/', '_'))
      Bots.UpdateBotBalance().then(() => {
        this.updPrices()
      })
    },

    onkeyDown (e) {
      if (
        [46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+C
        (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+V
        (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: Ctrl+X
        (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)
      ) {
        // let it happen, don't do anything
        return
      }

      if (!e.target.value.includes('.')) {
        if (e.key === ',' || e.key === 'ю') {
          // change ',' to '.'
          setTimeout(function () {
            e.target.value += '.'
          }, 4)
          e.preventDefault()
        } else if (e.key === '.') {
          // let '.' happen
          return
        }
      }

      // Ensure that it is a number and stop the keypress
      if (
        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
      ) {
        e.preventDefault()
      }
    }
  }
}
</script>
